import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import { getClickAttrs } from '../Analytics/gtag';
import Img from '../Img';
import BallType from '../text/BallType';
import { getTeamPaymentTypeOfDivision, isDoublesDivision } from '../../utils/events';
import InvitedPlayer from '../../pages/EventProfiles/EventProfilePageV3/PageComponents/InvitedPlayer';

import styles from './eventRegForm.scss';

const DivisionSelection = ({
    disabled,
    division,
    handleClick,
    subTitle,
    description,
    callToAction,
    divisionPrice,
    divisionPriceDescription,
    divisionPriceDescriptionAlt,
    errorText,
    selected,
    ageRestrictionText,
    sportTypeId,
}) => {
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const {
        types: {
            tms: {
                division: {
                    teamPaymentTypes,
                },
            },
        },
    } = coreUI;

    const { registerAsIndividual } = division;

    const teamPaymentTypeText = registerAsIndividual ? 'Individual player only' : getTeamPaymentTypeOfDivision(division, teamPaymentTypes);
    const isDoubles = isDoublesDivision(division);

    return (
        <>
            <div className={`radio-button radio-button-xl noselect ${selected && 'checked'} ${disabled && 'disabled disabled-divison-selection'}`}>
                <input
                    id={`division${division.id}`}
                    type="checkbox"
                    checked={selected}
                    disabled={disabled}
                    onChange={() => handleClick(division)}
                    {...getClickAttrs({
                        category: 'Event Profile CTA',
                        location: 'Register toggle division',
                        context: `Register toggle division - ${division.id}`,
                    })}
                />
                <label htmlFor={`division${division.id}`} className={errorText && `error`}>
                    <div className="radio-button-check">
                        {selected && <Img src="/img/icons/checkmark-icon.svg" />}
                    </div>
                    <div className="radio-button-label">
                        <div className="d-flex justify-content-between">
                            <div className={`${divisionPriceDescription ? 'w-50' : 'w-75'} text-break`}>
                                {divisionPriceDescription && (
                                    <div className="border">
                                        <p className="m-0 text-center text-small text-capitalize">{divisionPriceDescription}</p>
                                    </div>
                                )}
                                <div>{division.name}</div>
                                {!!division.ballType && <div className="radio-button-description fs12 text-bold"><BallType ballType={division.ballType} /></div>}
                                {teamPaymentTypeText && <div className="radio-button-description fs12 text-bold">{teamPaymentTypeText}</div>}
                                {ageRestrictionText && <div className="radio-button-description fs12 text-bold">{ageRestrictionText}</div>}
                                {subTitle && <div className="radio-button-description fs12 text-bold">{subTitle}</div>}
                            </div>
                            <div className="d-flex flex-col justify-content-between justify-content-center align-items-center ml-auto">
                                <div className="price text-right">
                                    {divisionPrice()}
                                </div>
                                {divisionPriceDescriptionAlt && (
                                    <div className="text-right text-teal description">
                                        {divisionPriceDescriptionAlt}
                                    </div>
                                )}
                            </div>
                        </div>
                        {isDoubles && division.player2 && (
                            <div className={styles.partnerSection}>
                                <InvitedPlayer
                                    player={division.player2}
                                    showDescription={!division.player2.needsPartner}
                                    sportTypeId={sportTypeId}
                                />
                            </div>
                        )}
                        <div className="radio-button-description">{description}</div>
                        {callToAction && (
                            <div className="w-100 mt-2">
                                {callToAction()}
                            </div>
                        )}
                        {division.maxPlayers && division.registeredCount >= division.maxPlayers && (
                            <div className={'text-small text-error description'}>
                                Division is full. You can register for the waitlist but please coordinate with the event organizer to see if you make it into the event before you make any travel plans. If you don’t make it, you will be refunded your entire fees.
                            </div>
                        )}
                    </div>
                </label>
            </div>
            {errorText && (
                <div className={`text-small text-error mt-12 mb16 ${styles.termAndConditions}`}>{errorText}</div>
            )}
        </>
    );
};

DivisionSelection.propTypes = {
    disabled: PropTypes.bool,
    division: PropTypes.objectOf(any).isRequired,
    handleClick: PropTypes.func,
    subTitle: PropTypes.string,
    description: PropTypes.string,
    callToAction: PropTypes.func,
    divisionPrice: PropTypes.number,
    divisionPriceDescription: PropTypes.string,
    divisionPriceDescriptionAlt: PropTypes.string,
    errorText: PropTypes.string,
    selected: PropTypes.bool,
    ageRestrictionText: PropTypes.string,
};

DivisionSelection.defaultProps = {
    disabled: false,
    handleClick: () => {},
    subTitle: '',
    description: '',
    callToAction: () => {},
    divisionPrice: 0,
    divisionPriceDescription: '',
    divisionPriceDescriptionAlt: '',
    errorText: '',
    selected: false,
    ageRestrictionText: '',
};

export default DivisionSelection;
